import React from "react";
import CourseHeroSection from "../components/coursespage/CourseHeroSection";

const CoursePage = () => {
  return (
    <div>
      <CourseHeroSection />
    </div>
  );
};

export default CoursePage;
